import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const PresetsPage = () => {
  const [cart, setCart] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<string | null>(null);

  const presets = [
    {
      id: 1,
      name: 'Lumière Parisienne',
      price: 9.99,
      description: 'Preset pour capturer la magie de Paris',
      image: 'https://public.readdy.ai/ai/img_res/9dbb8805873599016351256cc569425d.jpg',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20photo%20before%20preset%2C%20Paris%20street%20photography%2C%20natural%20lighting%2C%20unedited%20image%2C%20raw%20photography&width=200&height=300&seq=before-1&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20preset%20photo%2C%20Paris%20golden%20hour%20effect%2C%20warm%20tones%2C%20professional%20color%20grading&width=200&height=300&seq=after-1&orientation=portrait'
      ],
      features: ['Tons chauds dorés', 'Contraste optimisé', 'Saturation équilibrée', 'Compatible Lightroom & Mobile'],
      downloads: 1247,
      rating: 4.8,
    },
    {
      id: 2,
      name: 'Golden Mood',
      price: 14.99,
      description: 'Pack de 5 presets pour ambiance dorée',
      image: 'https://readdy.ai/api/search-image?query=Golden%20mood%20photography%20preset%20collection%2C%20warm%20golden%20tones%2C%20luxury%20aesthetic%2C%20professional%20photo%20editing%2C%20multiple%20preset%20variations&width=400&height=300&seq=preset-2&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20portrait%20photo%20before%20preset%2C%20natural%20lighting%2C%20unedited%20image%2C%20neutral%20tones&width=200&height=300&seq=before-2&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20golden%20mood%20preset%2C%20warm%20golden%20tones%2C%20enhanced%20skin%20tones%2C%20luxury%20aesthetic&width=200&height=300&seq=after-2&orientation=portrait'
      ],
      features: ['5 presets inclus', 'Tons dorés signature', 'Peau sublimée', 'Guide d\'utilisation'],
      downloads: 892,
      rating: 4.9,
    },
    {
      id: 3,
      name: 'Creator Master Pro',
      price: 24.99,
      description: '15 presets + tutoriel complet',
      image: 'https://readdy.ai/api/search-image?query=Professional%20preset%20collection%20for%20content%20creators%2C%20comprehensive%20photo%20editing%20pack%2C%20multiple%20style%20variations%2C%20premium%20photography%20presets&width=400&height=300&seq=preset-3&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20lifestyle%20photo%20before%20preset%2C%20natural%20colors%2C%20unedited%20content%20creator%20image&width=200&height=300&seq=before-3&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20creator%20master%20preset%2C%20professional%20color%20grading%2C%20enhanced%20aesthetic%2C%20content%20creator%20style&width=200&height=300&seq=after-3&orientation=portrait'
      ],
      features: ['15 presets variés', 'Tutoriel vidéo 30min', 'Styles multiples', 'Support technique', 'Mises à jour gratuites'],
      downloads: 2156,
      rating: 5.0,
      popular: true,
    },
    {
      id: 4,
      name: 'Bella Hadid Vibes',
      price: 19.99,
      description: 'Style signature Bella Hadid - tons froids et contrastes',
      image: 'https://readdy.ai/api/search-image?query=Bella%20Hadid%20inspired%20photography%20preset%2C%20cool%20tones%2C%20high%20contrast%2C%20fashion%20model%20aesthetic%2C%20professional%20photo%20editing%2C%20moody%20lighting&width=400&height=300&seq=preset-bella&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20fashion%20photo%20before%20preset%2C%20natural%20lighting%2C%20unedited%20model%20portrait&width=200&height=300&seq=before-bella&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20Bella%20Hadid%20preset%2C%20cool%20tones%2C%20high%20contrast%2C%20fashion%20model%20aesthetic&width=200&height=300&seq=after-bella&orientation=portrait'
      ],
      features: ['Tons froids signature', 'Contraste élevé', 'Peau mate parfaite', 'Style mode haute couture'],
      downloads: 1543,
      rating: 4.9,
    },
    {
      id: 5,
      name: 'Kylie Jenner Glow',
      price: 17.99,
      description: 'Éclat glamour à la Kylie - tons chauds et lumineux',
      image: 'https://readdy.ai/api/search-image?query=Kylie%20Jenner%20inspired%20photography%20preset%2C%20warm%20glowing%20tones%2C%20glamorous%20lighting%2C%20beauty%20influencer%20aesthetic%2C%20professional%20photo%20editing&width=400&height=300&seq=preset-kylie&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20beauty%20photo%20before%20preset%2C%20natural%20lighting%2C%20unedited%20portrait&width=200&height=300&seq=before-kylie&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20Kylie%20Jenner%20preset%2C%20warm%20glowing%20tones%2C%20glamorous%20beauty%20aesthetic&width=200&height=300&seq=after-kylie&orientation=portrait'
      ],
      features: ['Éclat naturel', 'Tons chauds dorés', 'Peau lumineuse', 'Style glamour'],
      downloads: 2087,
      rating: 4.8,
    },
    {
      id: 6,
      name: 'Hailey Bieber Clean',
      price: 16.99,
      description: 'Esthétique clean girl de Hailey Bieber',
      image: 'https://readdy.ai/api/search-image?query=Hailey%20Bieber%20inspired%20photography%20preset%2C%20clean%20girl%20aesthetic%2C%20minimal%20editing%2C%20natural%20beauty%2C%20soft%20lighting%2C%20professional%20photo%20editing&width=400&height=300&seq=preset-hailey&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20natural%20photo%20before%20preset%2C%20soft%20lighting%2C%20unedited%20clean%20portrait&width=200&height=300&seq=before-hailey&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20Hailey%20Bieber%20preset%2C%20clean%20girl%20aesthetic%2C%20natural%20beauty%20enhancement&width=200&height=300&seq=after-hailey&orientation=portrait'
      ],
      features: ['Beauté naturelle', 'Tons neutres', 'Éclairage doux', 'Style minimaliste'],
      downloads: 1789,
      rating: 4.7,
    },
    {
      id: 7,
      name: 'Gigi Hadid Editorial',
      price: 21.99,
      description: 'Style éditorial haute couture de Gigi Hadid',
      image: 'https://readdy.ai/api/search-image?query=Gigi%20Hadid%20inspired%20photography%20preset%2C%20editorial%20fashion%20style%2C%20high%20fashion%20aesthetic%2C%20professional%20model%20photography%2C%20dramatic%20lighting&width=400&height=300&seq=preset-gigi&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20editorial%20photo%20before%20preset%2C%20natural%20lighting%2C%20unedited%20fashion%20portrait&width=200&height=300&seq=before-gigi&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20Gigi%20Hadid%20preset%2C%20editorial%20fashion%20style%2C%20high%20fashion%20aesthetic&width=200&height=300&seq=after-gigi&orientation=portrait'
      ],
      features: ['Style éditorial', 'Contraste dramatique', 'Tons sophistiqués', 'Esthétique haute couture'],
      downloads: 1432,
      rating: 4.9,
    },
    {
      id: 8,
      name: 'Kendall Jenner Moody',
      price: 18.99,
      description: 'Ambiance sombre et mystérieuse de Kendall',
      image: 'https://readdy.ai/api/search-image?query=Kendall%20Jenner%20inspired%20photography%20preset%2C%20moody%20dark%20aesthetic%2C%20mysterious%20lighting%2C%20fashion%20model%20style%2C%20professional%20photo%20editing&width=400&height=300&seq=preset-kendall&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20moody%20photo%20before%20preset%2C%20natural%20lighting%2C%20unedited%20dark%20portrait&width=200&height=300&seq=before-kendall&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20Kendall%20Jenner%20preset%2C%20moody%20dark%20aesthetic%2C%20mysterious%20fashion%20style&width=200&height=300&seq=after-kendall&orientation=portrait'
      ],
      features: ['Ambiance sombre', 'Tons mystérieux', 'Contraste subtil', 'Style mode alternatif'],
      downloads: 1654,
      rating: 4.8,
    },
    {
      id: 9,
      name: 'Dua Lipa Retro',
      price: 15.99,
      description: 'Vibes rétro colorées inspirées de Dua Lipa',
      image: 'https://readdy.ai/api/search-image?query=Dua%20Lipa%20inspired%20photography%20preset%2C%20retro%20colorful%20aesthetic%2C%20vibrant%20tones%2C%20pop%20star%20style%2C%20professional%20photo%20editing&width=400&height=300&seq=preset-dua&orientation=landscape',
      beforeAfter: [
        'https://readdy.ai/api/search-image?query=Original%20colorful%20photo%20before%20preset%2C%20natural%20lighting%2C%20unedited%20vibrant%20portrait&width=200&height=300&seq=before-dua&orientation=portrait',
        'https://readdy.ai/api/search-image?query=After%20Dua%20Lipa%20preset%2C%20retro%20colorful%20aesthetic%2C%20vibrant%20pop%20star%20style&width=200&height=300&seq=after-dua&orientation=portrait'
      ],
      features: ['Tons retro vibrants', 'Couleurs saturées', 'Style pop', 'Esthétique années 80'],
      downloads: 1876,
      rating: 4.7,
    },
  ];

  const presetPacks = [
    {
      id: 1,
      name: 'Pack Débutant',
      price: 29,
      originalPrice: 49,
      description: '10 presets essentiels pour commencer',
      image: 'https://readdy.ai/api/search-image?query=Basic%20photo%20preset%20package%2C%20beginner%20photography%20filters%2C%20simple%20photo%20editing%20presets%2C%20starter%20pack%20design&width=400&height=300&seq=preset-1&orientation=landscape',
      presets: 10,
      includes: ['10 presets Lightroom', 'Guide d\'installation', 'Tutoriel vidéo'],
      popular: false,
    },
    {
      id: 2,
      name: 'Pack Influenceur',
      price: 59,
      originalPrice: 89,
      description: '25 presets pour un feed Instagram parfait',
      image: 'https://readdy.ai/api/search-image?query=Instagram%20influencer%20preset%20pack%2C%20social%20media%20photo%20filters%2C%20professional%20photography%20presets%2C%20influencer%20aesthetic&width=400&height=300&seq=preset-2&orientation=landscape',
      presets: 25,
      includes: ['25 presets premium', 'Presets stories', 'Templates Instagram', 'Support 30 jours'],
      popular: true,
    },
    {
      id: 3,
      name: 'Pack Pro Complet',
      price: 99,
      originalPrice: 149,
      description: '50 presets + formation + shooting avec Adel Saï',
      image: 'https://readdy.ai/api/search-image?query=Professional%20complete%20preset%20package%2C%20advanced%20photo%20editing%20collection%2C%20premium%20photography%20filters%2C%20professional%20photographer%20tools&width=400&height=300&seq=preset-3&orientation=landscape',
      presets: 50,
      includes: [
        '50 presets professionnels',
        'Formation retouche avancée',
        'Presets mobiles inclus',
        'Templates réseaux sociaux',
        '🔥 EXCLUSIF : Shooting avec Adel Saï (@Adofficielo)',
        '📱 5.4M TikTok • 2.6M Instagram • 1.6M Facebook',
        '🎬 Reel + TikTok avec mention collab garantis',
        'Support prioritaire'
      ],
      popular: false,
      adelSai: true,
    },
  ];

  const addToCart = (preset: any) => {
    setCart([...cart, preset]);
  };

  const handleBuyNow = async (preset: any) => {
    setIsLoading(preset.id.toString());
    
    try {
      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/create-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({
          productName: preset.name,
          price: preset.price,
          quantity: 1,
          productId: preset.id,
          productType: 'preset',
        }),
      });

      const data = await response.json();
      
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Erreur lors de la création du paiement');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la création du paiement');
    } finally {
      setIsLoading(null);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-20 px-4 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Photography%20preset%20showcase%2C%20professional%20photo%20editing%2C%20before%20and%20after%20comparison%2C%20content%20creator%20workspace%2C%20orange%20and%20black%20aesthetic&width=1920&height=1080&seq=presets-hero&orientation=landscape"
              alt="Presets"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/70"></div>
          </div>

          <div className="relative z-10 max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Presets <span className="text-orange-500">Photo Pro</span>
            </h1>
            <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
              Transformez vos photos avec nos presets professionnels. 
              Téléchargement immédiat et compatible avec tous les appareils.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a
                href="#presets"
                className="px-8 py-4 bg-orange-500 text-black font-semibold rounded-lg hover:bg-orange-600 transition-all duration-300 transform hover:scale-105"
              >
                Acheter un preset
              </a>
              <a
                href="#preview"
                className="px-8 py-4 bg-transparent border-2 border-orange-500 text-orange-500 font-semibold rounded-lg hover:bg-orange-500 hover:text-black transition-all duration-300"
              >
                Voir les exemples
              </a>
            </div>
          </div>
        </section>

        {/* Testimonials Section with Natural Reviews */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {[
                {
                  name: "Sarah M.",
                  rating: 5,
                  comment: "Incroyable ! Mes photos ont un rendu pro maintenant. J'ai gagné 15K followers en 1 mois 🔥",
                  verified: true
                },
                {
                  name: "Lucas D.",
                  rating: 4,
                  comment: "Super presets, faciles à utiliser sur iPhone. Quelques-uns sont un peu trop saturés pour mon goût mais globalement très content !",
                  verified: true
                },
                {
                  name: "Emma L.",
                  rating: 5,
                  comment: "OMG ces presets sont magiques ! Mes stories Instagram explosent depuis que je les utilise 😍",
                  verified: true
                },
                {
                  name: "Thomas R.",
                  rating: 4,
                  comment: "Bon rapport qualité/prix. Installation simple, résultats corrects. J'aurais aimé plus de variété dans les tons chauds.",
                  verified: false
                },
                {
                  name: "Léa K.",
                  rating: 5,
                  comment: "Les mêmes filtres que les influenceuses ! Enfin des photos qui claquent sur Insta 📸✨",
                  verified: true
                },
                {
                  name: "Antoine B.",
                  rating: 3,
                  comment: "Pas mal mais certains presets ne fonctionnent pas terrible avec les photos de nuit. Bon pour le jour par contre.",
                  verified: false
                }
              ].map((testimonial, index) => (
                <div
                  key={testimonial.name}
                  className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-gray-700 glass-effect animate-hologram hover-glow"
                  style={{
                    animation: `slideInUp 0.6s ease-out ${index * 0.1}s both, card-float 4s ease-in-out infinite`,
                    animationDelay: `${index * 0.1}s, ${index * 0.2}s`
                  }}
                >
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-gradient-to-r from-[#FF8A00] to-[#FF6B00] rounded-full flex items-center justify-center mr-4 animate-pulse-3d">
                      <span className="text-white font-bold text-lg">{testimonial.name.charAt(0)}</span>
                    </div>
                    <div>
                      <div className="flex items-center">
                        <h4 className="text-white font-semibold mr-2">{testimonial.name}</h4>
                        {testimonial.verified && (
                          <i className="ri-verified-badge-fill text-blue-400 text-sm animate-pulse-particle"></i>
                        )}
                      </div>
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className={`ri-star-${i < testimonial.rating ? 'fill' : 'line'} text-yellow-400 text-sm animate-pulse-star`}
                            style={{ animationDelay: `${i * 0.1}s` }}
                          ></i>
                        ))}
                        <span className="text-gray-400 text-sm ml-2">({testimonial.rating}/5)</span>
                      </div>
                    </div>
                  </div>
                  <p className="text-[#EAE7E2] italic animate-float">
                    "{testimonial.comment}"
                  </p>
                </div>
              ))}
            </div>

        {/* Presets Grid */}
        <section id="presets" className="py-20 px-4">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
              Nos <span className="text-orange-500">Presets</span> Exclusifs
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {presetPacks.map((pack) => (
                <div
                  key={pack.id}
                  className={`bg-gray-900 rounded-lg overflow-hidden hover:transform hover:scale-105 transition-all duration-300 ${
                    pack.popular ? 'border-2 border-orange-500' : ''
                  } ${pack.adelSai ? 'border-2 border-red-500' : ''}`}
                >
                  {pack.popular && (
                    <div className="bg-orange-500 text-black text-sm font-bold px-4 py-2 text-center">
                      PACK POPULAIRE
                    </div>
                  )}

                  {pack.adelSai && (
                    <div className="bg-gradient-to-r from-red-500 to-orange-500 text-white text-sm font-bold px-4 py-2 text-center animate-pulse">
                      PACK PREMIUM + ADEL SAÏ EXCLUSIF
                    </div>
                  )}

                  {/* Special badge for packs with Adel Saï */}
                  {pack.adelSai && (
                    <div className="absolute top-4 left-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-black px-3 py-1 rounded-full text-xs font-bold animate-pulse z-10">
                      + ADEL SAÏ EXCLUSIF
                    </div>
                  )}

                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={pack.image}
                      alt={pack.name}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="p-6">
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <h3 className="text-xl font-bold text-white mb-1">{pack.name}</h3>
                        <div className="flex items-center gap-2 mb-2">
                          <div className="flex">
                            {[...Array(5)].map((_, i) => (
                              <i
                                key={i}
                                className={`ri-star-${i < Math.floor(pack.rating) ? 'fill' : 'line'} text-orange-500 text-sm`}
                              ></i>
                            ))}
                          </div>
                          <span className="text-gray-400 text-sm">({pack.downloads} téléchargements)</span>
                        </div>
                      </div>
                      <p className="text-2xl font-bold text-orange-500">{pack.price}€</p>
                    </div>

                    <p className="text-gray-300 mb-6">{pack.description}</p>

                    <div className="mb-6">
                      <h4 className="text-white font-semibold mb-3">Inclus :</h4>
                      <ul className="space-y-2">
                        {pack.includes.map((feature, index) => (
                          <li key={index} className="flex items-start text-gray-300 text-sm">
                            <i className="ri-check-line text-orange-500 mr-2 mt-0.5 flex-shrink-0"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="flex gap-3 mb-3">
                      <button
                        onClick={() => addToCart(pack)}
                        className="flex-1 bg-transparent border border-orange-500 text-orange-500 font-semibold py-3 rounded-lg hover:bg-orange-500 hover:text-black transition-colors"
                      >
                        Ajouter au panier
                      </button>
                    </div>

                    <button
                      onClick={() => handleBuyNow(pack)}
                      disabled={isLoading === pack.id.toString()}
                      className={`w-full py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 ${
                        pack.popular
                          ? 'bg-orange-500 text-black hover:bg-orange-600'
                          : 'bg-orange-500 text-black hover:bg-orange-600'
                      } disabled:opacity-50 disabled:cursor-not-allowed`}
                    >
                      {isLoading === pack.id.toString() ? (
                        <>
                          <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
                          Redirection...
                        </>
                      ) : (
                        <>
                          <i className="ri-secure-payment-line"></i>
                          Acheter maintenant
                        </>
                      )}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Before/After Preview */}
        <section id="preview" className="py-20 px-4 bg-gray-900">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
              Avant / <span className="text-orange-500">Après</span>
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {presets.slice(0, 6).map((preset) => (
                <div key={preset.id} className="bg-gray-800 rounded-lg p-6">
                  <h3 className="text-xl font-bold text-white mb-4 text-center">{preset.name}</h3>
                  
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <p className="text-gray-400 text-sm mb-2 text-center">Avant</p>
                      <img
                        src={preset.beforeAfter[0]}
                        alt="Avant"
                        className="w-full aspect-[3/4] object-cover rounded-lg"
                      />
                    </div>
                    <div>
                      <p className="text-orange-500 text-sm mb-2 text-center">Après</p>
                      <img
                        src={preset.beforeAfter[1]}
                        alt="Après"
                        className="w-full aspect-[3/4] object-cover rounded-lg"
                      />
                    </div>
                  </div>

                  <button
                    onClick={() => handleBuyNow(preset)}
                    disabled={isLoading === preset.id.toString()}
                    className="w-full py-2 bg-orange-500 text-black font-semibold rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {isLoading === preset.id.toString() ? (
                      <>
                        <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
                        Redirection...
                      </>
                    ) : (
                      <>
                        <i className="ri-secure-payment-line"></i>
                        Acheter {preset.price}€
                      </>
                    )}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How to Use */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
              Comment <span className="text-orange-500">utiliser</span> nos presets ?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  step: '1',
                  title: 'Téléchargez',
                  description: 'Achetez et téléchargez instantanément vos presets',
                  icon: 'ri-download-line',
                },
                {
                  step: '2',
                  title: 'Importez',
                  description: 'Importez dans Lightroom, VSCO ou votre app préférée',
                  icon: 'ri-upload-line',
                },
                {
                  step: '3',
                  title: 'Appliquez',
                  description: 'Appliquez en un clic et ajustez selon vos goûts',
                  icon: 'ri-magic-line',
                },
              ].map((step, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-2xl text-black`}></i>
                  </div>
                  <div className="w-8 h-8 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-orange-500 font-bold">{step.step}</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
                  <p className="text-gray-400">{step.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-gray-900 rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold text-white mb-4">Compatible avec :</h3>
              <div className="flex justify-center items-center gap-8 flex-wrap">
                <span className="text-gray-300">Adobe Lightroom</span>
                <span className="text-gray-300">VSCO</span>
                <span className="text-gray-300">Snapseed</span>
                <span className="text-gray-300">Lightroom Mobile</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Cart Summary */}
      {cart.length > 0 && (
        <div className="fixed bottom-4 right-4 bg-orange-500 text-black p-4 rounded-lg shadow-lg z-50">
          <p className="font-semibold">Panier: {cart.length} preset(s)</p>
          <p className="text-sm">
            Total: {cart.reduce((sum, item) => sum + item.price, 0).toFixed(2)}€
          </p>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default PresetsPage;
